import {MeetingRole} from './customEnum'

let MEETING_ROLE = MeetingRole.doctor

const getRole = () => {
	return MEETING_ROLE
}

const setRole = (role) => {
	MEETING_ROLE = role
}

export {
	getRole,
	setRole
}
